var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentNode.funList && _vm.currentNode.funList.length > 0
    ? _c("div", { staticClass: "deviceMsg content-box forbit-cancel-tree" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("deviceSip.devMsg")))]),
        _c(
          "div",
          { staticClass: "msg-box" },
          [
            _c("h4", [
              _c("span", { staticClass: "title-box" }, [
                _c("i", { staticClass: "error-color" }, [_vm._v("* ")]),
                _vm._v(" " + _vm._s(_vm.$t("deviceSip.deviceName")) + " "),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.currentNode.name))]),
            ]),
            _c("h4", [
              _c("span", { staticClass: "title-box" }, [
                _c("i", { staticClass: "error-color" }, [_vm._v("*")]),
                _vm._v(" " + _vm._s(_vm.$t("deviceSip.function")) + " "),
              ]),
              _c(
                "div",
                [
                  _c(
                    "RadioGroup",
                    {
                      model: {
                        value: _vm.currentNode.productType,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentNode, "productType", $$v)
                        },
                        expression: "currentNode.productType",
                      },
                    },
                    _vm._l(_vm.allDevList, function (item) {
                      return _c(
                        "Radio",
                        {
                          key: item.value,
                          attrs: { label: item.value, disabled: "" },
                        },
                        [_c("span", [_vm._v(_vm._s(item.label))])]
                      )
                    }),
                    1
                  ),
                  Number(_vm.currentNode.productType) == 0
                    ? _c(
                        "Row",
                        { staticClass: "margin-box", attrs: { gutter: "20" } },
                        [
                          _c(
                            "i-col",
                            { attrs: { span: "22" } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: {
                                    disabled: "",
                                    placeholder: _vm.$t(
                                      "deviceType.deviceTypeTip"
                                    ),
                                  },
                                  model: {
                                    value: _vm.currentNode.deviceType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.currentNode,
                                        "deviceType",
                                        $$v
                                      )
                                    },
                                    expression: "currentNode.deviceType",
                                  },
                                },
                                _vm._l(_vm.deviceTypeList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.value,
                                      attrs: { value: item.value },
                                    },
                                    [_vm._v(" " + _vm._s(item.label) + " ")]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "CheckboxGroup",
                    {
                      staticClass: "margin-top-10",
                      model: {
                        value: _vm.currentNode.funList,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentNode, "funList", $$v)
                        },
                        expression: "currentNode.funList",
                      },
                    },
                    _vm._l(_vm.allFunList, function (item) {
                      return _c(
                        "Checkbox",
                        {
                          key: item.value,
                          attrs: { label: item.value, disabled: "" },
                        },
                        [_c("span", [_vm._v(_vm._s(item.label))])]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("h4", [
              _c("span", { staticClass: "error-color title-box" }, [
                _vm._v(" " + _vm._s(_vm.$t("deviceSip.net")) + " "),
              ]),
              _c("div", [
                _c(
                  "h4",
                  [
                    _c("span", { staticClass: "title-box" }, [
                      _vm._v(" " + _vm._s(_vm.$t("deviceSip.netType"))),
                    ]),
                    _c(
                      "RadioGroup",
                      {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.currentNode.netInfoDTO.mode,
                          callback: function ($$v) {
                            _vm.$set(_vm.currentNode.netInfoDTO, "mode", $$v)
                          },
                          expression: "currentNode.netInfoDTO.mode",
                        },
                      },
                      [
                        _c("Radio", { attrs: { label: 1, disabled: "" } }, [
                          _c("span", [_vm._v("Static")]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.currentNode.netInfoDTO.mode === 1
                  ? _c("div", [
                      _c("h4", [
                        _c("span", { staticClass: "title-box" }, [
                          _vm._v(_vm._s(_vm.$t("updateNewSip.mask"))),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentNode.netInfoDTO.mask)),
                        ]),
                      ]),
                      _c("h4", [
                        _c("span", { staticClass: "title-box" }, [
                          _vm._v(_vm._s(_vm.$t("updateNewSip.gateway"))),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentNode.netInfoDTO.gateway)),
                        ]),
                      ]),
                      _c("h4", [
                        _c("span", { staticClass: "title-box" }, [
                          _vm._v(_vm._s(_vm.$t("updateNewSip.ip"))),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentNode.netInfoDTO.ip)),
                        ]),
                      ]),
                      _c("h4", [
                        _c("span", { staticClass: "title-box" }, [
                          _vm._v("DNS1"),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentNode.netInfoDTO.dns1)),
                        ]),
                      ]),
                      _c("h4", [
                        _c("span", { staticClass: "title-box" }, [
                          _vm._v("DNS2"),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.currentNode.netInfoDTO.dns2
                                ? _vm.currentNode.netInfoDTO.dns2
                                : _vm.$t("updateNewSip.noData")
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._l(_vm.currentNode.sipInfoDTOList, function (item, index) {
              return _c("h4", { key: index }, [
                _c("span", { staticClass: "error-color title-box" }, [
                  _vm._v(
                    " sip" +
                      _vm._s(index + 1) +
                      " " +
                      _vm._s(_vm.$t("deviceSip.config")) +
                      " "
                  ),
                ]),
                _c("div", [
                  _c(
                    "h4",
                    [
                      _c("span", { staticClass: "title-box" }, [
                        _vm._v(" " + _vm._s(_vm.$t("deviceSip.mode"))),
                      ]),
                      _c(
                        "RadioGroup",
                        {
                          model: {
                            value: item.mode,
                            callback: function ($$v) {
                              _vm.$set(item, "mode", $$v)
                            },
                            expression: "item.mode",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: 1, disabled: "" } }, [
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.$t("deviceSip.mode1"))),
                            ]),
                          ]),
                          _c("Radio", { attrs: { label: 2, disabled: "" } }, [
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.$t("deviceSip.mode2"))),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("h4", [
                    _c("span", { staticClass: "title-box" }, [
                      _vm._v(_vm._s(_vm.$t("deviceSip.userTitle"))),
                    ]),
                    _c("span", [_vm._v(_vm._s(item.account))]),
                  ]),
                  item.mode === 2
                    ? _c("h4", [
                        _c("span", { staticClass: "title-box" }, [
                          _vm._v(_vm._s(_vm.$t("deviceSip.passwordTitle"))),
                        ]),
                        _c("span", [_vm._v(_vm._s(item.password))]),
                      ])
                    : _vm._e(),
                  item.mode === 2
                    ? _c("h4", [
                        _c("span", { staticClass: "title-box" }, [
                          _vm._v("ServerIp"),
                        ]),
                        _c("span", [_vm._v(_vm._s(item.serviceIp))]),
                      ])
                    : _vm._e(),
                  item.mode === 2
                    ? _c(
                        "h4",
                        [
                          _c("span", { staticClass: "title-box" }, [
                            _vm._v(
                              _vm._s(_vm.$t("deviceSip.protocolTypeTitle"))
                            ),
                          ]),
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: item.protocolType,
                                callback: function ($$v) {
                                  _vm.$set(item, "protocolType", $$v)
                                },
                                expression: "item.protocolType",
                              },
                            },
                            [
                              _c(
                                "Radio",
                                { attrs: { label: 1, disabled: "" } },
                                [_c("span", [_vm._v("UDP")])]
                              ),
                              _c(
                                "Radio",
                                { attrs: { label: 2, disabled: "" } },
                                [_c("span", [_vm._v("TCP")])]
                              ),
                              _c(
                                "Radio",
                                { attrs: { label: 3, disabled: "" } },
                                [_c("span", [_vm._v("TLS")])]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ])
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }